import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import { fetchWeatherActions } from './actions/fetchWeatherActions';
import templates from './templates';
import './WeatherWidget.css';

// Icon mapping outside component for better performance
const WEATHER_ICON_MAP = {
  '01d': '☀️', // clear sky day
  '01n': '🌙', // clear sky night
  '02d': '⛅', // few clouds day
  '02n': '☁️', // few clouds night
  '03d': '☁️', // scattered clouds
  '03n': '☁️',
  '04d': '☁️', // broken clouds
  '04n': '☁️',
  '09d': '🌧️', // shower rain
  '09n': '🌧️',
  '10d': '🌦️', // rain day
  '10n': '🌧️', // rain night
  '11d': '⛈️', // thunderstorm
  '11n': '⛈️',
  '13d': '❄️', // snow
  '13n': '❄️',
  '50d': '🌫️', // mist
  '50n': '🌫️'
};

const WeatherWidget = ({
  template = 'Card',
  location, // קואורדינטות {lat, lng}
  cityName, // שם העיר בעברית
  WEATHER_WIDTH,
  WEATHER_HEIGHT,
  weather,
  loading,
  error,
  title = 'מזג אוויר',
  showTitle = false,
  dispatch
}) => {

  const pollingIntervalRef = useRef(null);
  const previousLocationRef = useRef(location);

  useEffect(() => {
    // טען נתונים בטעינה ראשונה או בשינוי מיקום
    const locationChanged = JSON.stringify(previousLocationRef.current) !== JSON.stringify(location);

    if (locationChanged) {
      dispatch(fetchWeatherActions(location, cityName));
      previousLocationRef.current = location;
    } else {
      dispatch(fetchWeatherActions(location, cityName));
    }

    // רענון כל חצי שעה
    pollingIntervalRef.current = setInterval(() => {
      dispatch(fetchWeatherActions(location, cityName));
    }, 30 * 60 * 1000); // 30 דקות

    return () => {
      clearInterval(pollingIntervalRef.current);
    };
  }, [dispatch, location, cityName]);

  const getWeatherIcon = useCallback((iconCode) => {
    return WEATHER_ICON_MAP[iconCode] || '🌤️';
  }, []);

  // בחר את התבנית הנכונה
  const TemplateComponent = useMemo(() => templates[template] || templates.Card, [template]);

  return (
    <TemplateComponent
      weather={weather}
      loading={loading}
      error={error}
      getWeatherIcon={getWeatherIcon}
      title={title}
      showTitle={showTitle}
      WEATHER_WIDTH={WEATHER_WIDTH}
      WEATHER_HEIGHT={WEATHER_HEIGHT}
    />
  );
};

export { WeatherWidget };